import { Box, Divider, Image, Stack, Text } from '@mantine/core';

import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Link from '../../components/Link';
import paths from '../paths';

function Section({ title, content }: { title: string; content: string }) {
return (
<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{title}
</Text>
<Text fz="sm">
{content.split('\n').map((line, index) => (
// eslint-disable-next-line react/no-array-index-key
<Box mb="xs" key={index}>
{line}
</Box>
))}
</Text>
</Stack>
);
}

function SubSection({ title, content }: { title: string; content: string }) {
return (
<Stack gap="xs" pl="md">
<Text fz="1.25rem" ff="var(--ff-title)">
{title}
</Text>
<Text fz="sm">
{content.split('\n').map((line, index) => (
// eslint-disable-next-line react/no-array-index-key
<Box mb="xs" key={index}>
{line}
</Box>
))}
</Text>
</Stack>
);
}

export default function TermsOfService() {
const { t } = useTranslation();

return (
<Fragment>
<Helmet>
<title>
{t('legal.termsOfService.pageTitle')}
</title>
</Helmet>

<Stack w="100%">
<Stack my="xl">
<Stack gap="md">
<Stack gap="md">
<Text fz="2rem" ff="var(--ff-title)" c="teal.6">
{t('legal.termsOfService.title')}
</Text>
<Text fz="sm" fw="300">
{t('legal.termsOfService.lastUpdated')}
</Text>
</Stack>

<Divider />

<Text fz="sm">
{t('legal.termsOfService.intro')}
</Text>

<Section
title={t('legal.termsOfService.descriptionOfService.title')}
content={t('legal.termsOfService.descriptionOfService.content')}
/>

<Section
title={t('legal.termsOfService.eligibility.title')}
content={t('legal.termsOfService.eligibility.content')}
/>

<Section
title={t('legal.termsOfService.accountRegistration.title')}
content={t('legal.termsOfService.accountRegistration.content')}
/>

<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{t('legal.termsOfService.userConduct.title')}
</Text>
<Text fz="sm">
{t('legal.termsOfService.userConduct.content')
.split('\n')
.map((line, index) => (
// eslint-disable-next-line react/no-array-index-key
<Box mb="xs" key={index}>
{line}
</Box>
))}
</Text>
<Text fz="sm" fw="600">
{t('legal.termsOfService.userConduct.enforcement')
.split('\n')
.map((line, index) => (
// eslint-disable-next-line react/no-array-index-key
<Box mb="xs" key={index}>
{line}
</Box>
))}
</Text>
</Stack>

<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{t('legal.termsOfService.contentOwnership.title')}
</Text>
<SubSection
title={t('legal.termsOfService.contentOwnership.yourContent.title')}
content={t('legal.termsOfService.contentOwnership.yourContent.content')}
/>
<SubSection
title={t('legal.termsOfService.contentOwnership.contentResponsibility.title')}
content={t('legal.termsOfService.contentOwnership.contentResponsibility.content')}
/>
<SubSection
title={t('legal.termsOfService.contentOwnership.anonymousQuestions.title')}
content={t('legal.termsOfService.contentOwnership.anonymousQuestions.content')}
/>
<SubSection
title={t('legal.termsOfService.contentOwnership.noEndorsement.title')}
content={t('legal.termsOfService.contentOwnership.noEndorsement.content')}
/>
</Stack>

<Section
title={t('legal.termsOfService.intellectualProperty.title')}
content={t('legal.termsOfService.intellectualProperty.content')}
/>

<Section
title={t('legal.termsOfService.privacy.title')}
content={t('legal.termsOfService.privacy.content')}
/>

<Section
title={t('legal.termsOfService.thirdPartyServices.title')}
content={t('legal.termsOfService.thirdPartyServices.content')}
/>

<Section
title={t('legal.termsOfService.disclaimerOfWarranties.title')}
content={t('legal.termsOfService.disclaimerOfWarranties.content')}
/>

<Section
title={t('legal.termsOfService.limitationOfLiability.title')}
content={t('legal.termsOfService.limitationOfLiability.content')}
/>

<Section
title={t('legal.termsOfService.indemnification.title')}
content={t('legal.termsOfService.indemnification.content')}
/>

<Section
title={t('legal.termsOfService.copyrightInfringement.title')}
content={t('legal.termsOfService.copyrightInfringement.content')}
/>

<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{t('legal.termsOfService.termination.title')}
</Text>
<SubSection
title={t('legal.termsOfService.termination.byWhispi.title')}
content={t('legal.termsOfService.termination.byWhispi.content')}
/>
<SubSection
title={t('legal.termsOfService.termination.byYou.title')}
content={t('legal.termsOfService.termination.byYou.content')}
/>
<SubSection
title={t('legal.termsOfService.termination.effectOfTermination.title')}
content={t('legal.termsOfService.termination.effectOfTermination.content')}
/>
</Stack>

<Section
title={t('legal.termsOfService.modificationsToTerms.title')}
content={t('legal.termsOfService.modificationsToTerms.content')}
/>

<Section
title={t('legal.termsOfService.governingLaw.title')}
content={t('legal.termsOfService.governingLaw.content')}
/>

<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{t('legal.termsOfService.generalProvisions.title')}
</Text>
<SubSection
title={t('legal.termsOfService.generalProvisions.severability.title')}
content={t('legal.termsOfService.generalProvisions.severability.content')}
/>
<SubSection
title={t('legal.termsOfService.generalProvisions.waiver.title')}
content={t('legal.termsOfService.generalProvisions.waiver.content')}
/>
<SubSection
title={t('legal.termsOfService.generalProvisions.entireAgreement.title')}
content={t('legal.termsOfService.generalProvisions.entireAgreement.content')}
/>
<SubSection
title={t('legal.termsOfService.generalProvisions.assignment.title')}
content={t('legal.termsOfService.generalProvisions.assignment.content')}
/>
<SubSection
title={t('legal.termsOfService.generalProvisions.forceMajeure.title')}
content={t('legal.termsOfService.generalProvisions.forceMajeure.content')}
/>
</Stack>

<Section
title={t('legal.termsOfService.contact.title')}
content={t('legal.termsOfService.contact.content')}
/>
</Stack>

<Stack
mt="4rem"
gap="md"
align="center"
justify="center"
>
<Image w="5rem" src="/assets/logo.svg" />
<Text
lh="1"
fz="2rem"
to={paths.home}
component={Link}
ff="var(--ff-title)"
>
whispi.io
</Text>
</Stack>
</Stack>
</Stack>
</Fragment>
);
}
